<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>门诊预约问诊管理</el-breadcrumb-item>
        <el-breadcrumb-item>专家就诊管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="demo-app">
      <div class="demo-app-sidebar">
        <div class="demo-app-sidebar-section">
          <h2>预约列表 ({{ currentEvents.length }})</h2>
          <ul>
            <li v-for="event in currentEvents" :key="event.id" class="li-item">
              <b>{{ formatDate(event.start, "yyyy-MM-dd hh:mm") }}</b>
              <b> 至 </b>
              <b>{{ formatDate(event.end, "yyyy-MM-dd hh:mm") }}</b>
              <i>{{ event.title }}</i>
            </li>
          </ul>
        </div>
      </div>
      <div class="demo-app-main">
        <el-select filterable remote v-model="doctorId" :remote-method="remoteMethod" placeholder="请搜索并选择医生" @change="onDoctorChange">
          <el-option v-for="(item, index) in doctorList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <FullCalendar style="margin-top: 20px" class="demo-app-calendar" :options="calendarOptions" ref="fullCalendar">
          <template v-slot:eventContent="arg">
            <b>{{ arg.timeText }}</b>
            <i>{{ arg.event.title }}</i>
          </template>
        </FullCalendar>
      </div>
      <el-dialog width="70%" :visible.sync="dialogVisible" :title="title" @close="dialogClose">
        <el-form :model="dialogParams" label-width="120px" ref="form">
          <el-form-item label="就诊医院：" prop="diagnosisLocationId">
            <el-select filterable v-model="diagnosisLocationId" placeholder="请选择就诊医院">
              <el-option v-for="(item, index) in diagnosisList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <div v-for="(item, index) in timeData" :key="index">
            <el-form-item label="预约时段：">
              <el-time-select
                placeholder="起始时间"
                v-model="item.startTimeLong"
                :picker-options="{
                  start: '08:00',
                  step: '00:15',
                  end: '12:00',
                }"
              >
              </el-time-select>
              <span style="padding: 0 10px">至</span>
              <el-time-select
                placeholder="结束时间"
                v-model="item.endTimeLong"
                :picker-options="{
                  start: '08:00',
                  step: '00:15',
                  end: '12:00',
                  minTime: item.startTimeLong,
                }"
              >
              </el-time-select>
              <el-button v-if="item.startTimeLong && item.endTimeLong" style="margin-left: 10px" @click="removeTime(item.id, index)" type="danger">删除时段</el-button>
            </el-form-item>
            <el-form-item label="可预约人数：">
              <el-input-number v-model="item.canUserCount" :min="0"></el-input-number>
            </el-form-item>
          </div>
          <div style="text-align: right">
            <el-button type="info" @click="addTime">新增时段</el-button>
            <el-button @click="dialogVisible = false">关闭</el-button>
            <el-button @click="setCalendar" type="primary" :disabled="isDisabled">确定</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },
  data: function () {
    return {
      dialogVisible: false,
      dialogParams: {},
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin, // needed for dateClick
        ],
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        },
        initialView: "dayGridMonth",
        initialEvents: [], // alternatively, use the `events` setting to fetch from a feed
        events: [],
        editable: false,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        eventsSet: this.handleEvents,
        locale: "zh-cn",
        buttonText: { today: "今天", month: "月", week: "周", day: "日" },
        nowIndicator: true,
        displayEventEnd: true, // 是否显示结束时间
        /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
        datesSet: this.handleMonthChange,
      },
      currentEvents: [],
      title: "",
      doctorList: [],
      doctorId: "",
      isDisabled: false,
      timeData: [],
      diagnosisList: [],
      diagnosisLocationId: "",
      selectInfo: {},
      workMonth: "",
      currentDate: "",
    };
  },
  mounted() {
    this.loadDoctorList("");
    this.loadDiagnosisList();
  },
  methods: {
    /**
     * @description: 加载医生列报表
     * @param {*}
     * @return {*}
     */
    loadDoctorList(name) {
      this.$http({
        url: global.apiUrl + "/medical/doctor/list",
        method: "GET",
        params: {
          name,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.doctorList = res.body.data.dataList;
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 获取就诊地址
     * @param {*}
     * @return {*}
     */
    loadDiagnosisList() {
      this.$http({
        url: global.apiUrl + "/medical/diagnosis/list",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.diagnosisList = res.body.data;
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    remoteMethod(name) {
      this.loadDoctorList(name);
    },
    /**
     * @description: 医生选择事件
     * @param {*} doctorId
     * @return {*}
     */
    onDoctorChange(doctorId) {
      if (doctorId) {
        this.doctorId = doctorId;
        this.loadCalendarEvents(doctorId, this.currentDate);
      }
    },
    /**
     * @description: 加载日历事件
     * @param {*} doctorId
     * @return {*}
     */
    loadCalendarEvents(doctorId, workMonth) {
      console.log(workMonth);
      workMonth === "" ? this.formatDate(new Date().getTime(), "yyyy-MM") : this.currentDate;
      console.log(workMonth);
      this.$http({
        url: global.apiUrl + "/medical/doctor/rule",
        method: "GET",
        params: {
          doctorId,
          workMonth: workMonth,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.calendarOptions.events = [];
            const data = res.body.data;
            data.map(item => {
              item.data.map(d => {
                this.calendarOptions.events.push({
                  id: d.id,
                  title: "",
                  start: this.formatDate(d.startTimeLong, "yyyy-MM-dd hh:mm"),
                  end: this.formatDate(d.endTimeLong, "yyyy-MM-dd hh:mm"),
                });
              });
            });
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 生成时间戳
     * @param {*} time
     * @return {*}
     */
    setTimeStamp(time) {
      if (time) {
        return new Date(`${this.title} ${time}`).getTime();
      }
      return "";
    },
    /**
     * @description: 格式化日期
     * @param {*} timestamp
     * @param {*} fmt
     * @return {*}
     */
    formatDate(timestamp, fmt) {
      const date = new Date(timestamp);
      const o = {
        "M+": date.getMonth() + 1, // 月份
        "d+": date.getDate(), // 日
        "h+": date.getHours(), // 小时
        "m+": date.getMinutes(), // 分
        "s+": date.getSeconds(), // 秒
        "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds(), // 毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return fmt;
    },
    removeTime(id, index) {
      this.$confirm("确认删除该条预约时段数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (id) {
          this.$http({
            url: global.apiUrl + "/medical/doctor/rule/delete",
            method: "DELETE",
            params: {
              id,
            },
          }).then(res => {
            if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
              this.$message.success("删除成功");
              this.handleDateSelect(this.selectInfo);
              this.timeData.splice(index, 1);
            } else {
            }
          });
        } else {
          this.timeData.splice(index, 1);
        }
      });
    },
    addTime() {
      const params = {
        startTimeLong: "",
        endTimeLong: "",
        canUserCount: 0,
      };
      this.timeData.push(params);
    },
    /**
     * @description: 对话框关闭事件
     * @param {*}
     * @return {*}
     */
    dialogClose() {
      this.dialogVisible = false;
      this.dialogParams = this.$options.data().dialogParams;
    },
    /**
     * @description: 设置日历
     * @param {*}
     * @return {*}
     */
    setCalendar() {
      this.isDisabled = true;
      let data = JSON.parse(JSON.stringify(this.timeData));
      data = data.map(item => {
        item.startTimeLong = this.setTimeStamp(item.startTimeLong);
        item.endTimeLong = this.setTimeStamp(item.endTimeLong);
        return item;
      });
      const bodyParams = Object.assign(
        {},
        {
          doctorId: this.doctorId,
          workMonth: this.formatDate(new Date(this.title).getTime(), "yyyy-MM"),
          serialNumber: new Date(this.title).getDate(),
          workDateLong: new Date(this.title).getTime(),
          weekStr: this.formatWeek(new Date(this.title).getDay()),
          diagnosisLocationId: this.diagnosisLocationId,
          data,
        }
      );
      this.$http({
        url: global.apiUrl + "/medical/doctor/rule",
        method: "POST",
        body: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success("预约事件设置成功");
            this.diagnosisLocationId = "";
            this.dialogVisible = false;
            this.loadCalendarEvents(this.doctorId, this.currentDate);
          } else {
          }
          this.isDisabled = false;
        })
        .catch(err => {
          console.error(err);
          this.isDisabled = false;
        });
    },
    /**
     * @description: 日历选择事件
     * @param {*} selectInfo
     * @return {*}
     */
    handleDateSelect(selectInfo) {
      this.selectInfo = selectInfo;
      if (!this.doctorId) {
        this.$message.error("请先选择医生再设置预约事件");
        return;
      }
      const calendarApi = selectInfo.view.calendar;
      calendarApi.unselect(); // clear date selection
      this.title = selectInfo.startStr;
      // this.diagnosisLocationId = "";
      // this.timeData = [{ startTimeLong: "", endTimeLong: "", canUserCount: 0 }];
      this.$http({
        url: global.apiUrl + "/medical/doctor/day/rule",
        method: "GET",
        params: {
          doctorId: this.doctorId,
          workDay: new Date(selectInfo.start).getTime(),
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            const data = res.body.data;
            if (data) {
              this.diagnosisLocationId = data.diagnosisLocationId;
              this.timeData = data.data.map(item => {
                item.startTimeLong = this.formatDate(item.startTimeLong, "hh:mm");
                item.endTimeLong = this.formatDate(item.endTimeLong, "hh:mm");
                return item;
              });
            }
            this.dialogVisible = true;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    handleEventClick(clickInfo) {
      console.log(clickInfo);
    },
    handleEvents(events) {
      this.currentEvents = events;
    },
    handleMonthChange(payload) {
      let workMonth = payload.view.title;
      if (this.workMonth !== workMonth) {
        this.workMonth = workMonth;
        workMonth = this.formatSpecMonth(workMonth);
        this.currentDate = workMonth;
        console.log("--", workMonth);
        this.loadCalendarEvents(this.doctorId, workMonth);
      }
    },
    formatSpecMonth(workMonth) {
      let year = workMonth.substring(0, workMonth.indexOf("年"));
      let month = workMonth.substring(workMonth.indexOf("年") + 1, workMonth.length - 1);
      month = ("0" + month).slice(-2);
      return year + "-" + month;
    },
    formatWeek(num) {
      let weekStr = "星期";
      switch (num) {
        case 0:
          weekStr += "天";
          break;
        case 1:
          weekStr += "一";
          break;
        case 2:
          weekStr += "二";
          break;
        case 3:
          weekStr += "三";
          break;
        case 4:
          weekStr += "四";
          break;
        case 5:
          weekStr += "五";
          break;
        case 6:
          weekStr += "六";
          break;
        default:
          weekStr += "天";
          break;
      }
      return weekStr;
    },
  },
};
</script>

<style lang="css" scoped>
.li-item {
  margin: 10px 0;
}
.demo-app {
  display: flex;
  min-height: 100%;
  font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
  font-size: 14px;
}
.demo-app-sidebar {
  width: 300px;
  line-height: 1.5;
  background: #eaf9ff;
  border-right: 1px solid #d3e2e8;
}
.demo-app-sidebar-section {
  padding: 2em;
}
.demo-app-main {
  flex-grow: 1;
  padding: 3em;
}
.fc {
  /* the calendar root */
  max-width: 1100px;
  margin: 0 auto;
}
</style>
